import React from "react";
import { Procedure } from "../../../../application/domain/proc-management/core/types";
import { ServiceProviderProcManagementRoutes } from "../../../pages/service-provider/proc-management/routes";
import { ProcManagementR } from "../../../pages/proc-management/route";

export const ProcMasterLink: React.FC<{
  procMsts: Pick<Procedure, "id" | "name">[];
  isServiceProviderAccount: boolean;
  orgId: string;
}> = ({ procMsts, isServiceProviderAccount, orgId }) => {
  return (
    <div className="ml-5">
      <ul style={{ listStyleType: "disc" }}>
        {procMsts.map((p) => {
          const procDetailLink = isServiceProviderAccount
            ? ServiceProviderProcManagementRoutes.ProcManagementDetail.link({
                orgId: orgId,
                procId: p.id,
              })
            : ProcManagementR.ProcedureDetail.link({
                procId: p.id,
              });
          return (
            <li key={p.id}>
              <a
                className="has-text-link"
                href={procDetailLink}
                target="_blank"
                rel="noopener noreferrer"
              >
                {p.name}
              </a>
            </li>
          );
        })}
      </ul>
    </div>
  );
};
